This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div :class="[isRunning || true ? 'col-span-2' : 'col-span-3']"> 
    <ButtonBlock
      :saved="saveStatus"
      :editor="isEditor"
      :run="isRunning"
      :levelMakerAnswer="true"
      @changeMode="$emit('changeMode')"
      @changeAnswerMode="$emit('changeAnswerMode')"
      @runGame="$emit('runGame')"
      @toggleSolution="$emit('toggleSolution')"
      @undo="$emit('undo')"
      @redo="$emit('redo')"
      @stopRunning="$emit('stopRunning')"
      @setBreakpoint="$emit('setBreakpoint')"
      @continue="$emit('continue')"
      @saveGame="$emit('saveGame')"
      @previewGame="$emit('previewGame')"
    />
    <!-- Code or PSD area -->
    <PSDBlock v-if="true" />
    <CodeArea
      v-else
      ref="codeBlock"
      :run="isRunning"
      :highlight="highlightId"
      @breakpointsChanged="$emit('breakpointsChanged', $event)"
    />
  </div>
</template>

<script lang="ts">
// Libraries
import { Options, Vue } from "vue-class-component";

// Components
import ButtonBlock from "@/components/game/ButtonBlock.vue";
import PSDBlock from "@/components/game/psd/PSDBlock.vue";
import CodeArea from "@/components/game/CodeArea.vue";

@Options({
  emits: [
    "changeMode",
    "runGame",
    "toggleSolution",
    "undo",
    "redo",
    "stopRunning",
    "setBreakpoint",
    "continue",
    "saveGame",
    "breakpointsChanged",
  ],
  props: {
    isPSD: Boolean,
    isRunning: Boolean,
    highlightId: Number,
    saveStatus: String,
    isEditor: Boolean,
  },
  components: {
    ButtonBlock,
    PSDBlock,
    CodeArea,
  },
})
export default class GameInputs extends Vue {}
</script>
